import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateTagsFormField(
  params: FormFieldGenerationParams<'tags'>,
): PartialPropsOf<'tags'> {
  const col = params.inputData.column;

  let props: PartialPropsOf<'tags'> = applyPropsPatch(params.props, {
    style: {
      general: { offset: { margin: '$t.spacingFormField' } },
    },
  });

  if ((col.multipleValues ?? col.link?.multipleValues) !== true) {
    props = applyPropsPatch(props, {
      content: { options: { singleSelect: true } },
    });
  }

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, {
      content: { options: { readonly: true } },
      style: {
        input: {
          border: { selectorType: 'none' },
          fill: { color1: 'transparent' },
        },
      },
    });
  }

  return props;
}
